module.exports = __webpack_public_path__ + "static/img/introduce_8.1dbd825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_8.png
// module id = vbU3
// module chunks = 1